import React from 'react'
import RatingStars from 'src/widgets/RatingStars/RatingStars'

export default function SalesTemplate({ viewOnly = false, ratingData, onChange, submittedRating }) {

  const getTotalRating = () => {
    const {
      written_expression,
      output_of_work,
      responsibility,
      sales_target,
      targets_achieved,
      sales_growth,
      order_confirmed,
      monthly_calls,
      cases_processed,
      quotations_served,
      lost_sales,
      monthly_attendance,
    } = ratingData

    let total =
      parseInt(written_expression) +
      parseInt(output_of_work) +
      parseInt(responsibility) +
      parseInt(sales_target) +
      parseInt(targets_achieved) +
      parseInt(sales_growth) +
      parseInt(order_confirmed) +
      parseInt(monthly_calls) +
      parseInt(cases_processed) +
      parseInt(quotations_served) +
      parseInt(lost_sales) +
      parseInt(monthly_attendance)
    return total
  }

  const getSubmittedRating = () => {
    const {
      written_expression,
      output_of_work,
      responsibility,
      sales_target,
      targets_achieved,
      sales_growth,
      order_confirmed,
      monthly_calls,
      cases_processed,
      quotations_served,
      lost_sales,
      monthly_attendance,
    } = submittedRating

    let total =
      parseInt(written_expression) +
      parseInt(output_of_work) +
      parseInt(responsibility) +
      parseInt(sales_target) +
      parseInt(targets_achieved) +
      parseInt(sales_growth) +
      parseInt(order_confirmed) +
      parseInt(monthly_calls) +
      parseInt(cases_processed) +
      parseInt(quotations_served) +
      parseInt(lost_sales) +
      parseInt(monthly_attendance)
    return total
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        <table
          width="100%"
          className="table table-striped"
          style={{
            marginTop: '16px',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <tbody>
            <tr>
              <th style={{ width: '70px' }}>Misc. Aspects</th>
              <th style={{ width: '24px' }}>Submitted Rating</th>
              <th style={{ width: '24px' }}>RATING FACTORS</th>
              <th style={{ width: '6px' }}>RATING</th>
            </tr>
            <tr>
              <td colSpan={4}><strong>Quantitative Aspects</strong></td>
            </tr>
            <tr>
              <td>
                <strong>a. Written Expression</strong>
              </td>
              <td>{submittedRating.written_expression}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.written_expression}
                  onChange={(value) => onChange('written_expression', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.written_expression}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>b. Output of work </strong>
              </td>
              <td>{submittedRating.output_of_work}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.output_of_work}
                  onChange={(value) => onChange('output_of_work', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.output_of_work}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>c. Responsibility</strong>
              </td>
              <td>{submittedRating.responsibility}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.responsibility}
                  onChange={(value) => onChange('responsibility', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.responsibility}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <th colSpan={4}>Quantitative Aspects</th>
            </tr>
            <tr>
              <td>
                <strong>Monthly/yearly Sales Targets</strong>
              </td>
              <td>{submittedRating.sales_target}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.sales_target}
                  onChange={(value) => onChange('sales_target', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.sales_target}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Targets achieved Monthly/ yearly</strong>
              </td>
              <td>{submittedRating.targets_achieved}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.targets_achieved}
                  onChange={(value) => onChange('targets_achieved', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.targets_achieved}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Monthly sales Growth/Decline</strong>
              </td>
              <td>{submittedRating.sales_growth}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.sales_growth}
                  onChange={(value) => onChange('sales_growth', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.sales_growth}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Monthly order confirmed</strong>
              </td>
              <td>{submittedRating.order_confirmed}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.order_confirmed}
                  onChange={(value) => onChange('order_confirmed', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.order_confirmed}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Monthly Calls (or emails)</strong>
              </td>
              <td>{submittedRating.monthly_calls}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.monthly_calls}
                  onChange={(value) => onChange('monthly_calls', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.monthly_calls}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Cases Processed</strong>
              </td>
              <td>{submittedRating.cases_processed}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.cases_processed}
                  onChange={(value) => onChange('cases_processed', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.cases_processed}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>No of the quotations served</strong>
              </td>
              <td>{submittedRating.quotations_served}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.quotations_served}
                  onChange={(value) => onChange('quotations_served', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.quotations_served}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Lost sales due to unavailability of stores</strong>
              </td>
              <td>{submittedRating.lost_sales}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.lost_sales}
                  onChange={(value) => onChange('lost_sales', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.lost_sales}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Monthly Attendance</strong>
              </td>
              <td>{submittedRating.monthly_attendance}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.monthly_attendance}
                  onChange={(value) => onChange('monthly_attendance', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.monthly_attendance}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <b readOnly={viewOnly}>Overall Performance:</b>
              </td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getSubmittedRating()} / 110</td>
              <td></td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getTotalRating()} / 110</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
